// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center {
  width: 25%;
  margin: 10px auto;
}

.main-div {
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

button {
  margin-right: 10px;
}

/*.mat-icon {
  horizontal-align: right;

}*/
th {
  font-weight: bold;
  background-color: #E6E8EB;
}

table {
  width: 100%;
}

table thead th {
  color: white;
  font-size: 10pt;
  background-color: #3b5998;
}

.make-gold {
  background-color: #FAF6E2;
}

.make-red {
  background-color: #F0DDDD;
}

.make-green {
  background-color: #DEEED7;
}

li {
  margin-top: 5px;
  margin-left: 10px;
  padding: 2px;
}

.mat-fab {
  min-width: 100px;
  min-height: 75px;
}

.badge {
  float: right;
}

.content {
  padding: 5px;
}

.content > mat-card {
  width: 100px;
}

.nolist {
  list-style: none;
}

.example-margin {
  float: right;
  margin: 5px;
}

.example-headers-align {
  display: block;
  margin-top: 20px;
}

.badge {
  margin-left: auto;
}

.mat-expansion-panel {
  margin-bottom: 10px;
}

.mat-expansion-panel-header {
  margin-top: 10px;
}

.error-box {
  background-color: rgb(224, 52, 52);
  color: #fff;
}

.table-container {
  overflow-x: auto;
  max-width: 100%;
  margin-bottom: 10px;
}

.custom-table {
  width: 100%;
}

.heading {
  margin: auto;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  white-space: nowrap; /* Prevent text wrapping */
  overflow: hidden; /* Hide overflowing content */
  text-overflow: ellipsis; /* Show ellipsis for truncated text */
}

.edit-button {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/small-molecule/small-molecule.component.scss","webpack://./../../audit%20module/RedThread/src/app/pages/small-molecule/small-molecule.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,iBAAA;ACCF;;ADEA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACCF;;ADCA;EACE,kBAAA;ACEF;;ADCA;;;EAAA;AAIA;EACE,iBAAA;EACA,yBAAA;ACEF;;ADAA;EACE,WAAA;ACGF;;ADDA;EAAiB,YAAA;EAAc,eAAA;EAAgB,yBAAA;ACO/C;;ADNA;EACE,yBAAA;ACSF;;ADPA;EACE,yBAAA;ACUF;;ADRA;EACE,yBAAA;ACWF;;ADRA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;ACWF;;ADRA;EACE,gBAAA;EACA,gBAAA;ACWF;;ADRA;EACE,YAAA;ACWF;;ADPA;EACE,YAAA;ACUF;;ADPA;EACE,YAAA;ACUF;;ADPA;EACE,gBAAA;ACUF;;ADPA;EACE,YAAA;EACA,WAAA;ACUF;;ADNA;EACE,cAAA;EACA,gBAAA;ACSF;;ADNA;EACE,iBAAA;ACSF;;ADNA;EACE,mBAAA;ACSF;;ADNA;EACE,gBAAA;ACSF;;ADNA;EACE,kCAAA;EACA,WAAA;ACSF;;ADNA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;ACSF;;ADLA;EACE,WAAA;ACQF;;ADLA;EACE,YAAA;ACQF;;ADJA;EACE,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA,EAAA,0BAAA;EACA,gBAAA,EAAA,6BAAA;EACA,uBAAA,EAAA,qCAAA;ACOF;;ADJA;EACE,eAAA;ACOF","sourcesContent":[".center{\r\n  width: 25%;\r\n  margin: 10px auto;\r\n}\r\n\r\n.main-div{\r\n  height: 30vh;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\nbutton {\r\n  margin-right: 10px;\r\n}\r\n\r\n/*.mat-icon {\r\n  horizontal-align: right;\r\n\r\n}*/\r\nth {\r\n  font-weight: bold;\r\n  background-color: #E6E8EB;\r\n}\r\ntable {\r\n  width: 100%;\r\n}\r\ntable thead th { color: white; font-size:10pt; background-color: #3b5998}\r\n.make-gold {\r\n  background-color: #FAF6E2;\r\n}\r\n.make-red {\r\n  background-color: #F0DDDD;\r\n}\r\n.make-green {\r\n  background-color: #DEEED7;\r\n}\r\n\r\nli{\r\n  margin-top: 5px;\r\n  margin-left: 10px;\r\n  padding: 2px;\r\n}\r\n\r\n.mat-fab {\r\n  min-width: 100px;\r\n  min-height: 75px;\r\n}\r\n\r\n.badge {\r\n  float: right;\r\n}\r\n\r\n\r\n.content {\r\n  padding: 5px;\r\n}\r\n\r\n.content > mat-card {\r\n  width: 100px;\r\n}\r\n\r\n.nolist {\r\n  list-style: none;\r\n}\r\n\r\n.example-margin {\r\n  float: right;\r\n  margin: 5px;\r\n}\r\n\r\n\r\n.example-headers-align{\r\n  display: block;\r\n  margin-top: 20px;\r\n}\r\n\r\n.badge{\r\n  margin-left: auto;\r\n}\r\n\r\n.mat-expansion-panel{\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.mat-expansion-panel-header{\r\n  margin-top: 10px;\r\n}\r\n\r\n.error-box{\r\n  background-color:rgb(224, 52, 52);\r\n  color: #fff;\r\n}\r\n\r\n.table-container {\r\n  overflow-x: auto;\r\n  max-width: 100%; \r\n  margin-bottom: 10px;\r\n \r\n}\r\n\r\n.custom-table {\r\n  width: 100%;\r\n}\r\n\r\n.heading{\r\n  margin: auto;\r\n \r\n}\r\n\r\nth, td {\r\n  border: 1px solid #ddd;\r\n  padding: 8px;\r\n  text-align: left;\r\n  white-space: nowrap; /* Prevent text wrapping */\r\n  overflow:hidden; /* Hide overflowing content */\r\n  text-overflow: ellipsis; /* Show ellipsis for truncated text */\r\n}\r\n\r\n.edit-button{\r\n  cursor: pointer;\r\n}",".center {\n  width: 25%;\n  margin: 10px auto;\n}\n\n.main-div {\n  height: 30vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\nbutton {\n  margin-right: 10px;\n}\n\n/*.mat-icon {\n  horizontal-align: right;\n\n}*/\nth {\n  font-weight: bold;\n  background-color: #E6E8EB;\n}\n\ntable {\n  width: 100%;\n}\n\ntable thead th {\n  color: white;\n  font-size: 10pt;\n  background-color: #3b5998;\n}\n\n.make-gold {\n  background-color: #FAF6E2;\n}\n\n.make-red {\n  background-color: #F0DDDD;\n}\n\n.make-green {\n  background-color: #DEEED7;\n}\n\nli {\n  margin-top: 5px;\n  margin-left: 10px;\n  padding: 2px;\n}\n\n.mat-fab {\n  min-width: 100px;\n  min-height: 75px;\n}\n\n.badge {\n  float: right;\n}\n\n.content {\n  padding: 5px;\n}\n\n.content > mat-card {\n  width: 100px;\n}\n\n.nolist {\n  list-style: none;\n}\n\n.example-margin {\n  float: right;\n  margin: 5px;\n}\n\n.example-headers-align {\n  display: block;\n  margin-top: 20px;\n}\n\n.badge {\n  margin-left: auto;\n}\n\n.mat-expansion-panel {\n  margin-bottom: 10px;\n}\n\n.mat-expansion-panel-header {\n  margin-top: 10px;\n}\n\n.error-box {\n  background-color: rgb(224, 52, 52);\n  color: #fff;\n}\n\n.table-container {\n  overflow-x: auto;\n  max-width: 100%;\n  margin-bottom: 10px;\n}\n\n.custom-table {\n  width: 100%;\n}\n\n.heading {\n  margin: auto;\n}\n\nth, td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n  white-space: nowrap; /* Prevent text wrapping */\n  overflow: hidden; /* Hide overflowing content */\n  text-overflow: ellipsis; /* Show ellipsis for truncated text */\n}\n\n.edit-button {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
